// extracted by mini-css-extract-plugin
module.exports = {"productType":"styles_productType__cO1ue"};